import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useEffect } from "react";

export default function Form1() {
  const {
    register,
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  const overheadCostsToggle = watch("overheadCostsToggle");

  useEffect(() => {
    setValue("overheadCosts", "");
  }, [overheadCostsToggle]);

  return (
    <form className="d-flex flex-column py-3 gap-3">
      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>
          How much money does your company bill a year. (Total 1 year revenue){" "}
          <span className="require-star">*</span>
        </FormLabel>
        <TextField
          sx={{ maxWidth: 360 }}
          label="Your Answer"
          variant="standard"
          {...register("amount")}
          error={!!errors.amount}
          helperText={errors.amount ? errors.amount.message : ""}
        />
      </FormControl>

      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>
          Please select an option below about the material.{" "}
          <span className="require-star">*</span>
        </FormLabel>
        <Controller
          name="variableCost"
          control={control}
          render={({ field }) => (
            <RadioGroup {...field}>
              <FormControlLabel
                value="36%"
                control={<Radio />}
                label="My industry relies on material such as Plumbing HVAC, Electrical"
              />
              <FormControlLabel
                value="15%"
                control={<Radio />}
                label="My industry has material but we are more labor-driven such as Painters, Landscapers, Pressure washing"
              />
            </RadioGroup>
          )}
        />
        {errors.variableCost && (
          <span className="error">{errors.variableCost.message}</span>
        )}
      </FormControl>

      <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
        <FormLabel>
          Are you aware of your company's total expenses for 1 year (overhead
          not job related). Examples rent, all insurances, office labor pay &
          marketing there are also many more expenses. If you are not aware
          that's fine we will auto assign a number based off your industry you
          can always edit later on. Yes, will auto generate a number. No, you
          will provide your own number. <span className="require-star">*</span>
        </FormLabel>
        <Controller
          name="overheadCostsToggle"
          control={control}
          render={({ field }) => (
            <Select
              sx={{ maxWidth: 360 }}
              {...field}
              error={!!errors.overheadCostsToggle}
            >
              <MenuItem disabled value="">
                <em>Choose</em>
              </MenuItem>
              <MenuItem value={"yes"}>Yes</MenuItem>
              <MenuItem value={"no"}>No</MenuItem>
            </Select>
          )}
        />
        {errors.overheadCostsToggle && (
          <span className="error">{errors.overheadCostsToggle.message}</span>
        )}
      </FormControl>

      {overheadCostsToggle === "yes" && (
        <FormControl className="d-flex flex-column bg-white rounded-4 p-3 ">
          <FormLabel>
            What's your overhead cost for 1 year? (total of all non-job related
            expenses) <span className="require-star">*</span>
          </FormLabel>
          <TextField
            {...register("overheadCosts")}
            sx={{ maxWidth: 360 }}
            label="Your Answer"
            variant="standard"
            error={!!errors.overheadCosts}
            helperText={
              errors.overheadCosts ? errors.overheadCosts.message : ""
            }
          />
        </FormControl>
      )}
    </form>
  );
}
